module.exports = __webpack_public_path__ + "media/images/emails-and-contacts-1-04ad6e41d9e4fc74b2c88f3417336625.svg";